/*
 * SPDX-FileCopyrightText: 2022 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { GetApiRequestBuilder } from '../common/api-request-builder/get-api-request-builder';
import { PostApiRequestBuilder } from '../common/api-request-builder/post-api-request-builder';

export const postComment = async (data: any): Promise<any> => {
  const response = await new PostApiRequestBuilder<any, any>('', '', `comments`).withJsonBody({
    ...data
  }).sendRequest()
  return response.asParsedJsonObject()
}

export const postCommentPosition = async (data: any): Promise<any> => {
  const response = await new PostApiRequestBuilder<any, any>('', '', `comments/positions`).withJsonBody({
    ...data
  }).sendRequest()
  return response.asParsedJsonObject()
}

// /**
//  * Retrieves the comments metadata of the specified note.
//  *
//  * @param noteIdOrAlias The id or alias of the note.
//  * @return Metadata of the specified note.
//  */
export const getCommentsMetadata = async (noteIdOrAlias: string): Promise<any> => {
  const response = await new GetApiRequestBuilder<any>('', '', `comments/positions/${noteIdOrAlias}`).sendRequest()
  return response.asParsedJsonObject()
}

export const getCommentsContent = async (commentId: number): Promise<any> => {
  const response = await new GetApiRequestBuilder<any>('', '', `comments/${commentId}`).sendRequest()
  return response.asParsedJsonObject()
}

export const getCommentReplies = async (commentId: number): Promise<any> => {
  const response = await new PostApiRequestBuilder<any, any>('', '', `comments/${commentId}/replies`).sendRequest()
  return response.asParsedJsonObject()
}
